import PropTypes from 'prop-types'
import React from 'react'
import { Alert, Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * header title (react node)
   */
  title: PropTypes.node,
  /**
   * If true, show generic error banner
   */
  error: PropTypes.bool,
}

function ModalHeader(props) {
  const { error = false, title = null } = props ?? {}

  return (
    <Modal.Header className="grey-bg-color-1" closeButton>
      <Modal.Title>{title}</Modal.Title>
      <p className="mt-2 text-color-default">
        <FormattedMessage id="ENGAGE.MICROSOFT_365" />
      </p>
      <p className="mt-2 text-color-default">
        <FormattedMessage id="SECURE.CONDITIONAL_ACCESS_POLICY" />
      </p>
      {error && (
        <Alert variant="danger" className="d-flex align-items-baseline mb-0 mt-3">
          <i className="fas fa-triangle-exclamation me-2" />
          <FormattedMessage id="POLICY_GROUP.ERROR_SAVING" />
        </Alert>
      )}
    </Modal.Header>
  )
}

ModalHeader.propTypes = propTypes

export default ModalHeader
